import { render } from "./TrackersView.vue?vue&type=template&id=e84446a2&scoped=true"
import script from "./TrackersView.vue?vue&type=script&lang=js"
export * from "./TrackersView.vue?vue&type=script&lang=js"

import "./TrackersView.vue?vue&type=style&index=0&id=e84446a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Pablo Sastre\\OneDrive\\Escritorio\\BAIPManagerTestv2\\BaipMarket.Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e84446a2"]])

export default __exports__